module.exports = __webpack_public_path__ + "static/residential-gates-dd319cac37e6da0de0fa5c6e6a00fd07.jpg";